import React from 'react';
import Swal from 'sweetalert2';
import groupService from '../../services/api/groupService';
import { Button } from 'semantic-ui-react';
import { errorInput, scrollUp } from '../../components/helpers';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from '../../components/helpers/recaptchaUtils';
import styled from '@emotion/styled';
import {
  formQuestionList,
  newLeadersQuestions,
  endQuestionary,
} from '../../containers/groups/newLeaders/newLeadersQuestions';
import {
  isConditionalRequirementFailed,
  isQuestionVisible,
} from '../../containers/groups/newLeaders/missingConditions';
import { renderQuestions } from '../../components/helpers/renderFormQuestions';
import { screenSizes } from 'src/assets/styles/Literals';

const FormComp = styled('div')`
  width: 80%;
  max-width: ${screenSizes.desktop};
  margin: 0 auto;
  padding: 2rem;

  .Registration__form {
    background: white;
    text-align: start;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 2rem;
  }

  .form-prospect {
    text-align: center;
    max-width: 800px;
    margin: 0 auto;

    p {
      text-align: justify;
      line-height: 1.6;
      color: #333;
      margin-bottom: 1rem;
    }
  }

  .richText {
    max-width: 600px;
    margin: 2rem auto;
    padding: 1.5rem;
    text-align: justify;
    background: #f8f9fa;
    border-radius: 8px;

    p {
      margin: 0;
      line-height: 1.6;
    }
  }

  p.disciple-name {
    font-weight: 700;
    text-align: center;
    font-size: 2.5rem;
    color: #2c3e50;
    margin: 1.5rem 0;
  }

  h2 {
    margin: 2rem 0;
    color: #2c3e50;
    font-size: 1.8rem;
    font-weight: 600;
  }

  h4 {
    color: #666;
    margin: 1.5rem 0;
    font-weight: 500;
  }

  label {
    margin: 1rem 0 0.5rem 0;
    display: block;
    color: #444;
    font-weight: 500;
  }

  .error {
    color: #dc3545;
    font-size: 0.875rem;
    margin-top: 0.25rem;
  }

  .wellness-areas-checkbox {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    padding: 1.25rem 1.5rem;
    margin: 1.5rem 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 0.75rem 1rem;

    > label {
      grid-column: 1 / -1;
      margin: 0 0 0.25rem;
      font-weight: 600;
      color: #2c3e50;
      line-height: 1.5;
    }

    .ui.checkbox {
      margin: 0;

      label {
        font-size: 0.95rem;
        font-weight: 500;
        color: #495057;
        padding-left: 1.75rem;
        line-height: 1.4;

        &:before {
          width: 18px;
          height: 18px;
          border: 2px solid #ced4da;
          border-radius: 4px;
        }

        &:after {
          width: 10px;
          height: 10px;
          border-radius: 2px;
        }
      }

      &.checked label:before {
        background: #3498db;
        border-color: #3498db;
      }
    }
  }

  .wellness-counseling-radio {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 10px;
    padding: 1.25rem 1.5rem;
    margin: 0 0 1.5rem;

    > label {
      margin: 0 0 1rem;
      font-weight: 600;
      color: #2c3e50;
      line-height: 1.5;
    }

    .ui.checkbox {
      display: block;
      margin: 0 0 0.75rem;
      padding: 0.875rem 1rem;
      background: #fff;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      transition: border-color 0.2s ease, background-color 0.2s ease;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        border-color: #3498db;
        background: #f0f7ff;
      }

      &.checked {
        border-color: #3498db;
        background: #ebf5fb;
      }

      label {
        font-size: 0.95rem;
        font-weight: 400;
        color: #495057;
        padding-left: 1.75rem;
        line-height: 1.5;

        &:before {
          top: 1rem;
          width: 18px;
          height: 18px;
          border: 2px solid #ced4da;
        }

        &:after {
          top: 1rem;
          width: 10px;
          height: 10px;
        }
      }

      &.checked label:before {
        background: #3498db;
        border-color: #3498db;
      }
    }
  }

  #transversal {
    textarea {
      &.error {
        border: 2px solid #dc3545;
        background-color: #fff8f8;
        border-radius: 4px;
      }
    }
  }

  .ui.button {
    margin: 1.5rem 0.5rem 0 0.5rem;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }
  }

  @media screen and (max-width: 950px) {
    width: 90%;
    padding: 1rem;
  }

  @media screen and (max-width: 750px) {
    width: 100%;
    padding: 0.5rem;

    .Registration__form {
      padding: 1rem;
    }

    p.disciple-name {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.5rem;
    }

    .wellness-areas-checkbox {
      grid-template-columns: repeat(2, 1fr);
      padding: 1rem;
    }

    .wellness-counseling-radio {
      padding: 1rem;

      .ui.checkbox label {
        font-size: 0.9rem;
      }
    }
  }
`;

const NewLeadersForm = () => {
  const [guests, set_guests] = React.useState({});
  const [inputs, set_Inputs] = React.useState({});
  const [errorInputs, set_errorInputs] = React.useState({});
  const [errorGuestsInputs, set_errorGuestsInputs] = React.useState({});
  const [step, set_step] = React.useState(0);
  const [sent, set_sent] = React.useState(false);
  const [sending, set_sending] = React.useState(false);
  const getCaptchaToken = useRecaptchaToken('new_leader');
  const captchaRequired = isCaptchaRequired();

  const currentFormQuestions = (
    Array.isArray(newLeadersQuestions?.[inputs?.formQuestion]?.[step])
      ? newLeadersQuestions[inputs.formQuestion][step]
      : []
  ).filter((question) => question && isQuestionVisible(question, inputs));

  const verifyForm = () => {
    let errorInputs = {};
    const questions = currentFormQuestions;

    const questionsById = questions.reduce((acc, question) => {
      if (question?.id) acc[question.id] = question;
      return acc;
    }, {});

    Object.keys(questionsById).forEach((inputId) => {
      const question = questionsById[inputId];
      if (question.optional) return;

      if (question.optionalWhen) {
        const { id, value } = question.optionalWhen;
        if (inputs[id] === value) return;
      }

      if (question.requiredWhenFilled) {
        const conditionValue = inputs[question.requiredWhenFilled];
        const isFilled = Array.isArray(conditionValue)
          ? conditionValue.length > 0
          : Boolean(conditionValue);
        if (!isFilled) return;
      }

      const value = inputs[inputId];
      const normalizedValue = Array.isArray(value) && value.length === 0 ? undefined : value;
      errorInputs = errorInput({
        errorInputs,
        input: { name: inputId, value: normalizedValue },
      });
    });

    const conditionalQuestions = Object.keys(questionsById).filter((id) =>
      id.includes('conditional')
    );

    conditionalQuestions.forEach((inputId) => {
      const question = questionsById[inputId];
      if (isConditionalRequirementFailed(question, inputs[inputId], inputs)) {
        errorInputs = { ...errorInputs, not_allowed: true };
      }
    });
    set_errorInputs(errorInputs);

    if (errorInputs?.not_allowed) set_sent(true);

    let errorGuestsInputs = {};
    let mandatoryGuestsInputs = [];
    if (questions.some((el) => el?.type?.includes('form'))) {
      if (inputs?.info_couple_group || inputs?.formQuestion === 'Couple_Seminaries') {
        mandatoryGuestsInputs = {
          maleGuest: ['name', 'lastName', 'identification', 'phone'],
          femaleGuest: ['name', 'lastName', 'identification', 'phone'],
        };
      } else {
        mandatoryGuestsInputs = {
          guest: ['name', 'lastName', 'identification', 'phone'],
        };
      }
    }

    Object.entries(mandatoryGuestsInputs).forEach(([form, guestInputs]) => {
      guestInputs.forEach((input) => {
        errorGuestsInputs[form] = errorInput({
          errorInputs: errorGuestsInputs[form],
          input: { name: input, value: guests?.[form]?.[input] },
        });
      });
    });
    set_errorGuestsInputs(errorGuestsInputs);

    const guestsInputsFlags =
      Object.entries(errorGuestsInputs)?.reduce(
        (acc, [key, value]) => ({ ...acc, [key]: Object.values(value)?.some(Boolean) }),
        {}
      ) || {};

    return Object.values({
      ...errorInputs,
      ...guestsInputsFlags,
    }).includes(true);
  };

  let sendForm = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    set_sending(true);

    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_sending(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    let body = {
      ...guests,
      inputs,
      captcha,
    };
    groupService
      .newLeaderForm(body)
      .then((response) => {
        set_sending(false);
        if (response.data.success) {
          set_sent(true);
        }
        Swal.fire(response?.data?.message);
      })
      .catch((error) => {
        set_sending(false);
        Swal.fire(error?.response?.data?.message);
      });
  };

  const handleGuests = (event, person) => {
    const { name, value } = event.target;
    set_guests((prev) => ({
      ...prev,
      [person]: { ...(prev[person] || {}), [name]: value },
    }));
    set_errorGuestsInputs((prev) => ({
      ...prev,
      [person]: { ...(prev[person] || {}), [name]: false },
    }));
  };

  const handleInputs = (event) => {
    const { name, value } = event.target;
    set_Inputs((prev) => ({ ...prev, [name]: value }));
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const renderNewLeadersQuestions = (questions) =>
    renderQuestions({
      questions,
      errorInputs,
      inputs,
      set_Inputs,
      guests,
      handleInputs,
      handleGuests,
      sending,
      changeStep,
      sendForm,
      errorGuestsInputs,
    });

  const changeStep = (e, move) => {
    e.preventDefault();

    if (move === 'next') {
      scrollUp();
      if (verifyForm()) return;
      set_step(step + 1);
    } else {
      set_step(step - 1);
    }
  };

  if (sent) {
    return (
      <FormComp>
        <div className="Registration__form">
          {renderNewLeadersQuestions(
            endQuestionary(inputs.formQuestion, !errorInputs?.not_allowed, inputs)
          )}
        </div>
      </FormComp>
    );
  }
  if (inputs.formQuestion) {
    return (
      <FormComp>
        <div className="Registration__form">
          <Button
            onClick={() => {
              set_Inputs({});
              set_step(0);
            }}
            style={{ margin: '20px 0' }}
            disabled={sending}
          >
            Volver a comenzar
          </Button>
          <div className="form-prospect">
            {renderNewLeadersQuestions(currentFormQuestions)}
            <h4>Todos los campos son obligatorios.</h4>
          </div>
        </div>
      </FormComp>
    );
  }
  return (
    <FormComp>
      <div className="Registration__form">
        <div className="form-prospect">{renderNewLeadersQuestions(formQuestionList)}</div>
      </div>
    </FormComp>
  );
};

export default NewLeadersForm;
